module.exports = __webpack_public_path__ + "img/face42.28995ae9.gif";